import { render, staticRenderFns } from "./tagging.vue?vue&type=template&id=761454ce&scoped=true&"
import script from "./tagging.vue?vue&type=script&lang=js&"
export * from "./tagging.vue?vue&type=script&lang=js&"
import style0 from "./tagging.vue?vue&type=style&index=0&id=761454ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761454ce",
  null
  
)

export default component.exports